import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { CardLayout } from '@modules/card/enums/card-layout.enum';
import { Screen } from '@modules/shared/services/window.service';

import { CardComponent } from '../../card/card/card.component';
import { MediaComponent } from '../../media/media.component';
import { HeroSectionModel } from '../models/hero-section.model';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardComponent, MediaComponent],
})
export class HeroSectionComponent extends SectionDefaultsComponent {
  public largeLayouts = {
    [Screen.XXXS]: CardLayout.COLUMN,
    [Screen.SM]: CardLayout.HERO,
  };
  public smallLayout = {
    [Screen.XXXS]: CardLayout.COLUMN,
    [Screen.MD]: CardLayout.HERO,
  };
  public smallAlignments = {
    [Screen.XXXS]: 'top',
    [Screen.MD]: 'bottom',
  };
  @Input() data!: HeroSectionModel;
}
